import { CALYPSO } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIClickable from 'UIComponents/button/UIClickable';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import classNames from 'classnames';
import { getSuperCategoryI18nKey } from 'marketplace-ui-apps-core/common/utils/i18n';
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import { getCategoryI18nKey } from 'marketplace-ui-common/utils/i18n';
import { useRef, useState } from 'react';
import * as FilterKey from '../../../constants/search/FilterKey';
import { MobileBrowsePanel } from './MobileBrowsePanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MobileBrowseBarTitle({
  collection,
  filters,
  isAllCategories
}) {
  const {
    [FilterKey.CATEGORY]: category,
    [FilterKey.SUPER_CATEGORY]: superCategory
  } = filters;
  if (category) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: getCategoryI18nKey(category)
    });
  }
  if (superCategory) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: getSuperCategoryI18nKey(superCategory)
    });
  }
  if (isAllCategories) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.storefront.filters.category.items.all.titleText"
    });
  }
  if (collection && collection.publishedListing) {
    return /*#__PURE__*/_jsx("span", {
      children: collection.publishedListing.name
    });
  }
  return /*#__PURE__*/_jsx("span", {});
}
export function MobileBrowseBar({
  className,
  collection,
  filters,
  isAllCategories
}) {
  const sectionClasses = classNames('p-y-3', className);
  const [panelOpen, setPanelOpen] = useState(false);
  const mobileBrowseBarRef = useRef(null);
  const handlePanelCloseComplete = () => {
    var _mobileBrowseBarRef$c;
    (_mobileBrowseBarRef$c = mobileBrowseBarRef.current) === null || _mobileBrowseBarRef$c === void 0 || _mobileBrowseBarRef$c.focus();
  };
  return /*#__PURE__*/_jsxs(MainSection, {
    className: sectionClasses,
    color: "light",
    responsive: true,
    children: [/*#__PURE__*/_jsx(UIClickable, {
      buttonRef: mobileBrowseBarRef,
      onClick: () => setPanelOpen(true),
      onKeyDown: event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          setPanelOpen(true);
        }
      },
      tabIndex: 0,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "appMarketplace.storefront.mobileNavigation.browseBarTitle",
          options: {
            title: /*#__PURE__*/_jsx(MobileBrowseBarTitle, {
              collection: collection,
              filters: filters,
              isAllCategories: isAllCategories
            })
          }
        }), /*#__PURE__*/_jsx(UIIcon, {
          className: "m-left-auto",
          name: "right",
          color: CALYPSO,
          size: "xs"
        })]
      })
    }), /*#__PURE__*/_jsx(MobileBrowsePanel, {
      onClose: () => {
        setPanelOpen(false);
        handlePanelCloseComplete();
      },
      open: panelOpen
    })]
  });
}